import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { RecordContainer } from 'src/app/interfaces/record-container';
import { CNItem } from 'src/app/models/cnitem';
import { TypeManagerService } from 'src/app/services/type-manager.service';

export enum RecordContainerMode {
  compact = 'compact',
  summary = 'summary',
  full = 'full'
}

@Component({
  selector: 'app-record-container',
  templateUrl: './record-container.component.html',
  styleUrls: ['./record-container.component.scss']
})
export class RecordContainerComponent implements OnInit {

  @Input() record: CNItem;
  @Input() mode: RecordContainerMode = RecordContainerMode.compact;

  @ViewChild('recordContainer', {read: ViewContainerRef, static: true}) recordViewContainerRef: ViewContainerRef;

  private componentMapping: Map<string, any> = new Map();

  constructor(private typeManager: TypeManagerService) {
    // TODO: component managed by directives ...  but now it's manual
    this.componentMapping.set('SNItem.CNItem.CNHealthProblem', this.typeManager.typeMap('ProblemRowComponent'));
    this.componentMapping.set('SNItem.CNItem.CNMedication', this.typeManager.typeMap('MedicationRowComponent'));
    this.componentMapping.set('stvaast_protocol', this.typeManager.typeMap('ProtocolRowComponent'));
    this.componentMapping.set('stvaast_labo', this.typeManager.typeMap('LaboRowComponent'));
  }

  ngOnInit(): void {
    if (this.componentMapping.has(this.record.key) && this.recordViewContainerRef) {
      const componentRef = this.recordViewContainerRef.createComponent<RecordContainer>(this.componentMapping.get(this.record.key));
      componentRef.instance.record = this.record;
      componentRef.instance.mode = this.mode;
    }
  }
}
